import {connect} from 'react-redux';
import * as actionsManagement from '../../actions/management';
import * as actionsUMK from '../../actions/umk';
import { list } from '../../actions/faculty';


import LessonPlan from '../../components/LessonPlan/LessonPlan';
import { fetchCourse, fetchMetaCourse  } from '../../actions/educationWorkPrograms';
import { educationYear, getYears } from '../../actions/schedule';
import { getLessonPlan, getLessonPlanByYearAndFuk, getLessonPlanTerm } from '../../actions/lessonPlan';
import { schoolYear } from '../../actions/radar';


const mapStateToProps = ({lessonPlan, faculty, educationWorkPrograms, progressReport, schedule,  management, radar, auth, umk,  schedule: { educationYear },}) => ({
    management,
    faculties: management.faculty,
    disciplines: management.discipline,
    years: radar.scy,

    terms: management.academicPeriod,
    curriculum: umk.curriculum,
    coursesList: educationYear,
    facultyList: faculty.list,
    disciplineRPD: educationWorkPrograms.disciplineRPD,
    discipline: educationWorkPrograms.discipline,
    lessonPlanList: lessonPlan.lessonPlanList,
    isLoading: lessonPlan.isLoading,
    pagesCount: lessonPlan.pagesCount,
    lessonPlanListCur: lessonPlan.lessonPlanListCur,
    termLessonPlan: lessonPlan.termLessonPlan

});

const mapDispatchToProps = dispatch => ({
    getYears: ()=> dispatch(schoolYear()) ,
    getAcademicPeriod: yearId => dispatch(actionsManagement.getAcademicPeriod(yearId)),
    fetchCurriculum: (syid) => dispatch(actionsUMK.fetchCirriculum(syid)),
    getCoursesList: () => dispatch(educationYear()),
    fetchFacultyList: () => dispatch(list()),
    fetchCourse:(params)=> dispatch(fetchCourse(params)),
    fetchMetaCourse:(syid, curriculumId, cid) => dispatch(fetchMetaCourse(syid, curriculumId, cid)),
    getLessonPlan: (params) => dispatch (getLessonPlan(params)),
    getLessonPlanTerm: (params) => dispatch (getLessonPlanTerm(params)),
    getLessonPlanByYearAndFuk:(year, faculty) => dispatch(getLessonPlanByYearAndFuk(year, faculty)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LessonPlan);
